import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function supplierItemsHasErrored(bool) {
  return {
    type: 'SUPPLIER_ITEMS_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function supplierItemsIsLoading(bool) {
  return {
    type: 'SUPPLIER_ITEMS_IS_LOADING',
    isLoading: bool,
  };
}
export function supplierItemsFetchDataSuccess(items) {
  return {
    type: 'SUPPLIER_ITEMS_FETCH_DATA_SUCCESS',
    items,
  };
}

export function clearSupplierListData() {
  return {
    type: 'CLEAR_SUPPLIER_LIST_DATA',
  };
}

export function supplierItemHasErrored(bool) {
  return {
    type: 'SUPPLIER_ITEM_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function supplierItemIsLoading(bool) {
  return {
    type: 'SUPPLIER_ITEM_IS_LOADING',
    isLoading: bool,
  };
}
export function supplierItemFetchDataSuccess(item) {
  return {
    type: 'SUPPLIER_ITEM_FETCH_DATA_SUCCESS',
    item,
  };
}

export function purchaseRebateSupplierItemsHasErrored(bool) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_ITEMS_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function purchaseRebateSupplierItemsIsLoading(bool) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_ITEMS_IS_LOADING',
    isLoading: bool,
  };
}
export function purchaseRebateSupplierItemsFetchDataSuccess(items) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_ITEMS_FETCH_DATA_SUCCESS',
    items,
  };
}

export function purchaseRebateSupplierItemHasErrored(bool) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_ITEM_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function purchaseRebateSupplierItemIsLoading(bool) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_ITEM_IS_LOADING',
    isLoading: bool,
  };
}
export function purchaseRebateSupplierItemFetchDataSuccess(item) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_ITEM_FETCH_DATA_SUCCESS',
    item,
  };
}

export function newPurchaseRebateSupplierSaveSuccess(bool, prsupplier) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_SAVE_SUCCESS',
    isSaved: bool,
    prsupplier: prsupplier,
  };
}

export function newPurchaseRebateSupplierSaveErrored(bool, message) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_SAVE_ERRORED',
    hasErrored: bool,
    message: message,
  };
}

export function newPurchasedRebateSupplierIsSaving(bool) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_IS_SAVING',
    isSaving: bool,
  };
}

export function newPurchasedRebateSupplierIsRemoved(bool) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_IS_REMOVING',
    isSaving: bool,
  };
}

export function newPurchasedRebateSupplierRemoveError(bool, message) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_REMOVE_ERRORED',
    isSaving: bool,
    message: message,
  };
}

export function newPurchasedRebateSupplierRemoveSuccess(bool, prsupplier) {
  return {
    type: 'PURCHASE_REBATE_SUPPLIER_REMOVE_SUCCESS',
    isSaving: bool,
    prsupplier: prsupplier,
  };
}

function buildQueryString(id, name) {
  let queryString = '';

  queryString += 'SupplierId=' + id + '&SupplierName=' + name;

  return queryString ? '?' + queryString : queryString;
}

export function supplierItemsFetchData(id, name) {
  const queryString = buildQueryString(id, name);

  const url = queryString
    ? apiEndPoints.SUPPLIER_LIST + queryString
    : apiEndPoints.SUPPLIER_LIST;

  return (dispatch) => {
    dispatch(supplierItemsIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(supplierItemsIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(supplierItemsFetchDataSuccess(items)))
      .catch(() => {
        dispatch(supplierItemsHasErrored(true));
        dispatch(supplierItemsIsLoading(false));
      });
  };
}

export function getSupplierItem(id) {
  const url = apiEndPoints.SUPPLIER_ITEM.replace('SupplierId', id);

  return (dispatch) => {
    dispatch(supplierItemIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        dispatch(supplierItemIsLoading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((item) => dispatch(supplierItemFetchDataSuccess(item)))
      .catch(() => dispatch(supplierItemHasErrored(true)));
  };
}

export function purchaseRebateSupplierItemsFetchData() {
  const url = apiEndPoints.PURCHASE_REBATE_SUPPLIER_LIST;

  return (dispatch) => {
    dispatch(purchaseRebateSupplierItemsIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(purchaseRebateSupplierItemsIsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((items) =>
        dispatch(purchaseRebateSupplierItemsFetchDataSuccess(items)),
      )
      .catch(() => {
        dispatch(purchaseRebateSupplierItemsIsLoading(false));
        dispatch(purchaseRebateSupplierItemHasErrored(true));
      });
  };
}

export function getPurchaseRebateSupplierItem(id) {
  const url = `${apiEndPoints.PURCHASE_REBATE_SUPPLIER_ITEM}/${id}`;

  return (dispatch) => {
    dispatch(purchaseRebateSupplierItemIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        dispatch(purchaseRebateSupplierItemIsLoading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((item) =>
        dispatch(purchaseRebateSupplierItemFetchDataSuccess(item)),
      )
      .catch(() => dispatch(purchaseRebateSupplierItemHasErrored(true)));
  };
}

export function addPurchaseRebateSupplier(prsupplier) {
  const url = apiEndPoints.PURCHASE_REBATE_SUPPLIER_ADD;
  return (dispatch) => {
    dispatch(newPurchaseRebateSupplierSaveErrored(false, ''));
    dispatch(newPurchasedRebateSupplierIsSaving(true));

    adalApiFetch(fetch, url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(prsupplier),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(newPurchasedRebateSupplierIsSaving(false));

        if (response.ok) {
          response.json().then((prsupplier) => {
            dispatch(newPurchaseRebateSupplierSaveSuccess(true, prsupplier));
          });
        } else {
          switch (response.status) {
            case 422: {
              response.json().then((error) => {
                const items = Object.values(error);
                const message = items.join('; ');
                dispatch(newPurchaseRebateSupplierSaveErrored(true, message));
              });
              break;
            }
            case 400: {
              response
                .json()
                .then((error) =>
                  dispatch(
                    newPurchaseRebateSupplierSaveErrored(true, error.message),
                  ),
                );
              break;
            }
            default: {
              response
                .json()
                .then((error) =>
                  dispatch(
                    newPurchaseRebateSupplierSaveErrored(true, error.message),
                  ),
                );
              break;
            }
          }
        }
      })
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
      });
  };
}

export function removePurchaseRebateSupplier(id) {
  const url = `${apiEndPoints.PURCHASE_REBATE_SUPPLIER_DELETE}/${id}`;
  return (dispatch) => {
    dispatch(newPurchasedRebateSupplierIsSaving(true));

    adalApiFetch(fetch, url, {
      method: 'DELETE',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(newPurchasedRebateSupplierIsSaving(false));
        if (response.ok) {
          // eslint-disable-next-line no-console
          console.log('deleted');
          window.location.reload();
        } else {
          switch (response.status) {
            case 422: {
              response.json().then((error) => {
                const items = Object.values(error);
                const message = items.join('; ');
                dispatch(newPurchaseRebateSupplierSaveErrored(true, message));
              });
              break;
            }

            default: {
              response
                .json()
                .then((error) =>
                  dispatch(
                    newPurchaseRebateSupplierSaveErrored(true, error.message),
                  ),
                );
              break;
            }
          }
        }
      })
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
      });
  };
}
